import { Link } from '@tanstack/react-router'
import { Shell } from '../app/Shell'
import { Alert } from '../ui/kit'

export function NotFoundPage() {
  return (
    <Shell head={<div className="toolbar"><div className="tt"><h1 className="t-page">Not found</h1></div></div>} status={<span>Not found</span>}>
      <Alert info title="There is nothing at this address"><Link to="/">Back to the register</Link></Alert>
    </Shell>
  )
}
